export default function Alert({ type = 'danger', children }) {
  if (!children) return null
  const cls = type === 'success' ? 'alert alert-success' : 'alert alert-danger'
  return (
    <div className={cls} role="alert">
      {children}
    </div>
  )
}
